import { createFileRoute } from '@tanstack/react-router'
import ManageTeamIndex from '@/pages/settings/manage-team'

export const Route = createFileRoute('/_authenticated/settings/manage-team')({
  component: ManageTeamIndex,
})
